import { Component } from '@angular/core';


@Component({
	selector: 'finance-awards-accelerator-view-part',
	standalone: true,
	templateUrl: './finance-awards-accelerator-view.part.html',
	styleUrls: ['./finance-awards-accelerator-view.part.scss'],
})
export class FinanceAwardsAcceleratorViewPart {
}